import { atomFamily } from "jotai-family";
import { selectAtom } from "jotai/utils";
import { questionnaireCombinedErrorsAtom } from "./questionnaireCombinedErrorsAtom";

export const questionnaireErrorAtom = atomFamily((questionName: string) =>
  selectAtom(
    questionnaireCombinedErrorsAtom,
    errors => errors[questionName] as string | undefined,
  ),
);
